// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col-5[data-v-3b734cb4] {\n  width: 5%;\n}\n.col-8[data-v-3b734cb4] {\n  width: 8%;\n}\n.col-10[data-v-3b734cb4] {\n  width: 10%;\n}\n.col-12[data-v-3b734cb4] {\n  width: 12%;\n}", ""]);
// Exports
module.exports = exports;
